import React from "react";
import { Grid, Typography } from "@mui/material";
import { WEB_COLORS } from "@/lib/constants";

const ContentHeader = ({ heading, paragraph }) => {
  return (
    <Grid>
      <Typography
        variant="h4"
        fontWeight="700"
        gutterBottom
        color={WEB_COLORS.darkTeal}
        sx={{
          fontSize: {
            xs: 20,
            md: 40,
          },
          textAlign: { xs: "left", md: "center" },
        }}
      >
        {heading}
      </Typography>
      <Typography
        variant="subtitle1"
        color="#3F3F3FCC"
        mb={4}
        textAlign={"center"}
        sx={{
          fontSize: {
            xs: 12,
            md: 18,
          },
          textAlign: { xs: "left", md: "center" },
        }}
      >
        {paragraph}
      </Typography>
    </Grid>
  );
};

export default ContentHeader;
